// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__3NklA","iconImage":"Icon_iconImage__OrZyh","active":"Icon_active__A1Utm"};